//api
import { setNotifyToken } from "@/api/notifyToken";

export default {
  computed: {
    ...mapState(["isLogin"]),
    ...mapGetters(["notifyToken", "token"]),
  },
  created() {
    if (qs.notifyToken) this.$store.commit("cache/SET_NOTIFY_TOKEN", decodeURIComponent(qs.notifyToken));
  },
  methods: {
    async event_notifyToken() {
      if (this.isLogin) {
        if (!this.notifyToken || !this.token) {
          // appCallAlert('[Cannot_Event_notifyToken]\nnotifyToken: ' + JSON.stringify(this.notifyToken) + '\ntoken: ' + JSON.stringify(this.token));
          NOTIFICATION("e", '嘗試發送推播 Token 失敗, 請重新登入後再試');
          return;
        }

        try {
          await setNotifyToken();
        } catch (error) {
          // appCallAlert('!!!---[Api.Event_notifyToken Failed]---!!!\nnotifyToken: ' + JSON.stringify(this.notifyToken) + '\ntoken: ' + JSON.stringify(this.token));
          NOTIFICATION("e", '發送推播 Token 失敗, 請重新登入後再試');
        }
      };
    }
  }
}